// generated by genversion
export var version = '4.3.4';
//# sourceMappingURL=version.js.map